import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";
import { NAV_LINKS, scrollToId, scrollToTop } from "@/lib/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    window.setTimeout(() => scrollToId(id), open ? 200 : 0);
  };

  return (
    <>
      <header
        data-testid="header-navigation"
        className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
          scrolled || open
            ? "bg-cream/85 backdrop-blur-xl border-b border-hairline/80 py-3"
            : "bg-transparent py-5"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
          <button data-testid="header-logo" onClick={scrollToTop} aria-label="The Studio31 — home">
            <Logo />
          </button>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="relative text-[13px] tracking-wide text-espresso/80 hover:text-ink transition-colors group"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 h-px w-0 bg-brass transition-all duration-300 group-hover:w-full" />
              </button>
            ))}
            <button
              data-testid="header-consultation-button"
              onClick={() => go("contact")}
              className="bg-ink text-cream text-[13px] tracking-wide px-6 py-3 hover:bg-brass hover:text-ink transition-colors duration-300"
            >
              Book Consultation
            </button>
          </nav>

          <button
            className="lg:hidden p-2 -mr-2"
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      <div
        className={`fixed inset-0 z-40 bg-ink text-cream transition-all duration-500 lg:hidden ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="h-full flex flex-col justify-center px-8 pt-16">
          <Logo size="lg" onDark />
          <div className="mb-10" />
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-left font-serif text-4xl py-3 border-b border-white/10 hover:text-brass transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("contact")}
            className="mt-10 bg-brass text-ink px-6 py-4 font-display tracking-widest2 text-xs uppercase"
          >
            Book Consultation
          </button>
        </div>
      </div>
    </>
  );
}
